// ShowDetailPage.jsx
import { useState } from "react";
import { Box, Tabs, Tab, Typography, Alert } from "@mui/material";
import { useTranslation } from "i18n-fe";
import ShowHeader from "../components/ShowHeader";
import EntryList from "../components/EntryList";
import ShowDetailSkeleton from "../components/ShowDetailSkeleton";
import { useShow } from "../hooks/useShow";

export default function ShowDetailPage() {
  const { t } = useTranslation("common");
  const { show, loading, error } = useShow();
  const [tab, setTab] = useState(0);

  if (loading) {
    return <ShowDetailSkeleton />;
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  if (!show) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{t("shows.detail.notFound")}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", height: "calc(100vh - 155px + 15px)" }}>
      {/* Main vertical layout */}
      <Box sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {/* Top Section */}
        <ShowHeader show={show} />

        <Tabs value={tab} onChange={(_, newValue) => setTab(newValue)}>
          <Tab label={t("shows.detail.tabs.entries")} />
          <Tab label={t("shows.detail.tabs.reports")} />
          <Tab label={t("shows.detail.tabs.settings")} />
        </Tabs>

        {/* Scrollable content area */}
        <Box sx={{ flexGrow: 1, overflow: "hidden" }}>
          {tab === 0 && <EntryList showId={show.id} />}

          {tab === 1 && (
            <Box sx={{ p: 3 }}>
              <Typography variant="body1">(Reports UI placeholder)</Typography>
            </Box>
          )}

          {tab === 2 && (
            <Box sx={{ p: 3 }}>
              <Typography variant="body1">(Settings UI placeholder)</Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
